module.exports = __webpack_public_path__ + "img/mashup.c507da4a.svg";